import React from 'react';
import { Switch } from 'components/atoms/Buttons/Switchs/Switch';
import useStyle from '../../../formCommande.style';
import usePublicShop from 'hooks/usePublicShop';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from 'store/reducers';
import { MainFormState } from 'types/forms/form.def';
import { addClient as addClientAction } from 'store/actions';
import { copyDeliveryInformations as copyDeliveryInformationsAction } from 'store/actions/client.actions';
import { updateFraisPort } from 'store/actions/panier.actions';
import { initLivraison, initLivraisonError } from 'types/client/client.def';
import { errorAndStateParams } from 'helpers/forms/errorAndStateParams';
import { toBoolean } from 'helpers/forms/prettifyField';
import HorsLyceeFields from './HorsLycee';

const PrivateShopField = () => {
  const classes = useStyle();
  const { isPublicShop } = usePublicShop();
  let { client } = useSelector((state: AppState) => state);
  const dispatch = useDispatch();
  const addClient = (newParams: MainFormState<any>) =>
    dispatch(addClientAction(newParams));
  const updateFraisDePort = (isPortApplicable: boolean) =>
    dispatch(updateFraisPort(isPortApplicable));

  const livraisonFields = Object.keys(initLivraison);

  const handleChange = async e => {
    const value = e.target.value;
    const field = e.target.name;

    if (client.values.affilie || !client.values.livraisonhorslycee) {
      client.errors = {
        ...client.errors,
        mobilelivraison: false,
        nomlivraison: false,
        prenomlivraison: false
      };
    }

    if (
      (field === 'livraisonhorslycee' && value === 'true') ||
      client.values.livraisonhorslycee
    ) {
      livraisonFields.forEach(key => {
        if (
          client.values[key] === null ||
          client.values[key] === '---' ||
          client.values[key] === ''
        )
          client.errors = { ...client.errors, [key]: true };
      });
    }

    if (field === 'sameDeliveryInformation' && value === 'true') {
      client = {
        ...client,
        sameDeliveryInformation: true
      };
    }

    if (field === 'livraisonhorslycee' && value === 'false') {
      client = {
        ...client,
        values: {
          ...client.values,
          ...initLivraison,
          livraisonhorslycee: false
        },
        errors: { ...client.errors, ...initLivraisonError }
      };

      livraisonFields.map(
        key => (client.errors = { ...client.errors, [key]: false })
      );
    }

    if (field === 'sameDeliveryInformation' && value === 'false') {
      client = {
        ...client,
        sameDeliveryInformation: false
      };
    }

    !isPublicShop &&
      field === 'livraisonhorslycee' &&
      updateFraisDePort(toBoolean(value));

    if (field === 'clientpro' && value === 'false') {
      client.values = { ...client.values, nomsociete: null };
    }

    const newParams = errorAndStateParams(field, value, client);
    addClient(newParams);
    if (field === 'sameDeliveryInformation') {
      dispatch(copyDeliveryInformationsAction());
    }
  };
  const handleChangeSwitch = (value, name) => {
    const e = {
      target: {
        value: value.toString(),
        name: name
      }
    };
    handleChange(e);
  };

  return (
    <>
      <div className={classes.buttondiv}>
        <p>Le client souhaite une livraison directe par transporteur ?</p>
        <Switch
          onClick={value => handleChangeSwitch(value, 'livraisonhorslycee')}
          defaultValue={client.values.livraisonhorslycee}
        />
      </div>
      {client.values.livraisonhorslycee && (
        <>
          <div className={classes.buttondiv}>
            <p>Informations de livraison et facturation similaires ?</p>
            <Switch
              onClick={value =>
                handleChangeSwitch(value, 'sameDeliveryInformation')
              }
              defaultValue={client.sameDeliveryInformation}
            />
          </div>
          <HorsLyceeFields
            handleChange={handleChange}
            handleChangeSwitch={handleChangeSwitch}
            client={client.values}
            sameClient={client.sameDeliveryInformation}
            errors={client.errors}
          />
        </>
      )}
    </>
  );
};

export default PrivateShopField;
